module.exports = __webpack_public_path__ + "static/media/rich-lace-sm.2584dcb7.jpg";